<template>
    <div class="pl-lg-4">

        <div class="col-lg-12" v-if="isLoadingBlade">
            <div class="d-flex justify-content-center">
                <img :src="loadingBladeUrl" />
            </div>
        </div>

        <div v-if="! isLoadingBlade && ! showQualPage && ! showBulkUploadPage">
            <h3 class="text-uppercase">Non Academic / Suport Staff Information</h3>

            <em class="mb-4 text-danger">
                Kindly add personnels below...
            </em>

            <hr class="my-4"/>

            <!-- import institution details template here -->
            <StaffRecords
                :consultantRecords="consultantRecords"
                :showAddRecord="showAddRecord"
                v-on:editRecord="editRecord"
                v-on:deleteRecord="deleteRecord"
                v-on:addQualification="addQualification"
                :pagination="pagination"
                :hasPagination="hasPagination"
                :paginate="paginate"
            />

            <div class="col-lg-12" v-if="! hasRecords || showAddRecord">
                <h4>
                    For Bulk Upload of Non-Academic / Support Staff, do the following: <br>
                    i.  Kindly click on <em class="text-primary">Sample file</em> button below to 
                    download a Sample file (Excel format). <br>
                    ii. Populate the Sample file accordingly. <br>
                    iii. Click on <em class="text-success">Upload file</em> button below to upload Staff.
                </h4>
                <br><br>
            </div>

            <div class="row">
                <div 
                    class="col-lg-2" 
                    v-if="(! hasRecords || showAddRecord) && application && application.training_school_id"
                >
                    <form :action="getRootUrl+'/export-school-staff-sample'" method="POST">
                        
                        <input type="hidden" name="type" value="staff" />
                        <input type="hidden" name="id" :value="application.training_school_id" />

                        <button
                            class="btn btn-lg btn-primary"
                            nativeType="submit"
                        >
                            <i class="fa fa-file-export"></i>
                            Sample file
                        </button>
                    </form>
                </div>

                <div class="col-lg-10" v-if="! hasRecords || showAddRecord">
                    <input
                        type="file"
                        ref="photo"
                        style="display: none"
                        @change="onFileSelected"
                    >

                    <button
                        class="btn btn-lg btn-success"
                        @click="$refs.photo.click()"
                    >
                        <i class="fa fa-upload"></i>
                        Upload file
                    </button>
                </div>
            </div>

            <hr class="my-4"/>

            <div class="pl-lg-4" v-if="hasRecords && ! showAddRecord">
                <base-button
                    type="primary"
                    @click="displayAddPage()"
                >
                    <i class="fa fa-plus"></i>
                    Add New Record
                </base-button>
            </div>


            <div class="row align-items-center" v-if="! hasRecords || showAddRecord">

                <div class="col-lg-12 text-center">
                    <h2 class="text-uppercase">Add an Non-Academic / Support Staff</h2>
                </div>

                <div class="col-lg-12">
                    <hr class="my-4"/>
                </div>

                <!-- <div class="col-lg-3">
                    <base-input alternative=""
                        label="File Number"
                        placeholder="Enter File Number"
                        input-classes="form-control-alternative"
                        v-model="record.file_no"
                        type="number"
                        required
                    />
                </div> -->

                <div class="col-lg-3">
                    <base-input alternative=""
                        label="Surname"
                        placeholder="Enter Surname"
                        input-classes="form-control-alternative"
                        v-model="record.surname"
                        required
                    />
                </div>

                <div class="col-lg-3">
                    <base-input alternative=""
                        label="First Name"
                        placeholder="Enter First Name"
                        input-classes="form-control-alternative"
                        v-model="record.first_name"
                        required
                    />
                </div>

                <div class="col-lg-3">
                    <base-input alternative=""
                        label="Other Name"
                        placeholder="Enter Other Name"
                        input-classes="form-control-alternative"
                        v-model="record.other_name"
                    />
                </div>

                <div class="col-lg-3">
                    <base-input alternative=""
                        label="Previous Name"
                        placeholder="Enter Previous Name"
                        input-classes="form-control-alternative"
                        v-model="record.previous_name"
                    />
                </div>

                <div class="col-lg-4">
                    <base-input alternative=""
                        label="Position in the college"
                        placeholder="Enter Position"
                        input-classes="form-control-alternative"
                        v-model="record.position"
                        required
                    />
                </div>

                <div class="col-lg-4">
                    <base-input alternative=""
                        label="Rank in the college"
                        placeholder="Enter Rank"
                        input-classes="form-control-alternative"
                        v-model="record.rank"
                        required
                    />
                </div>

                <div class="col-lg-4">
                    <base-input alternative=""
                        label="Department"
                        placeholder="Enter Department"
                        input-classes="form-control-alternative"
                        v-model="record.department"
                        required
                    />
                </div>

                <div class="col-lg-12">
                    <base-alert :type="errorType" dismissible v-if='showInputErrorStatus'>
                        <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                        <span class="alert-inner--text">
                            {{errorMsg}}
                        </span>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </base-alert>
                </div>
                <div class="col-lg-12"></div>

                <div class="col-lg-12">
                    <base-button
                        type="success"
                        @click="saveDoctorRecord()"
                    >
                        <i class="fa fa-save"></i>
                        {{isloading ? 'Please Wait...' : updateButton }}
                    </base-button>

                    <div class="right" v-if="hasRecords">
                        <base-button
                            type="danger"
                            @click="displayAddPage()"
                        >
                            <i class="fa fa-times"></i>
                            Cancel
                        </base-button>
                    </div>
                </div>

            </div>

            <hr class="my-4"/>

            <div class="pl-lg-4">
                <base-button
                    type="danger"
                    @click="showPreviousPage()"
                >
                    <i class="fa fa-arrow-left"></i>
                    Previous
                </base-button>
                <div class="right">
                    <base-button
                        type="success"
                        @click="showNextPage()"
                        :disabled="! hasRecords"
                    >
                        Continue
                        <i class="fa fa-arrow-right"></i>
                    </base-button>
                </div>
            </div>
        </div>

        <Qualifications
            :id="id"
            :records="staff"
            :type="'staff'"
            v-on:addQualification="addQualification"
            :loadApplication="loadApplication"
            v-if="showQualPage && staff && ! showBulkUploadPage"
        />

        <StaffBulkUpload 
            :records="sheetRecords"
            :isloading="isloading"
            v-on:displayUploadPage="displayUploadPage"
            v-on:uploadStaffNow="uploadStaffNow"
            v-if="showBulkUploadPage"
        />

    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import StaffRecords from './StaffRecords/StaffRecords';
    import Qualifications from './Qualifications/Qualifications';
    import StaffBulkUpload from './StaffRecords/StaffBulkUpload.vue'
    import swal from 'sweetalert2';// import sweet alert
    import * as XLSX from "xlsx";

    export default {
        components: {
            StaffRecords,
            Qualifications,
            StaffBulkUpload
        },
        name: 'StaffData',
        props: ['loadApplication', 'application', 'id', 'displayConsultantData', 'displayFacilityData'],
        data() {
            return {
                consultantRecords: [],
                paginatedItems: [],
                record: {
                    file_no: null,
                    surname: null,
                    first_name: null,
                    other_name: null,
                    previous_name: null,
                    rank: null,
                    position: null,
                    department: null
                },
                pagination: {
                    total: null,
                    number: 1,
                    from: null,
                    perPage: this.$store.state.user.perPage // get per page count
                },
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isloading: false,
                showInputErrorStatus: false,
                isLoadingBlade: true,
                showAddRecord: false,
                newAccount: true,
                config: {
                    allowInput: true,
                    altInput: true,// eslint-disable-next-line
                    plugins: [new monthSelectPlugin({shorthand: true, dateFormat: "Y-m-d", altFormat: "M Y"})]
                },
                showQualPage: false,
                staff: [],
                sheetRecords: [],
                showBulkUploadPage: false
            };
        },
        computed: {
            ...mapGetters(['loadingBladeUrl', 'getRootUrl']),
            hasPagination() {
                return this.paginatedItems && (this.paginatedItems.length > this.pagination.perPage)
                    ? true : false;
            },
            hasRecords() {
                return this.consultantRecords && this.consultantRecords.length > 0;
            },
            updateButton() {
                return (this.record.id ? 'Update' : 'Add') + ' Record';
            }
        },
        methods: {
            ...mapActions(['updateSchoolData', 'deleteSchoolData', 'uploadBulkSchoolStaff']),
            displayAddPage() {
                this.emptyRecords();
                return this.showAddRecord = ! this.showAddRecord;
            },
            editRecord(data) {// edit record
                if(data) {
                    this.record = {
                        file_no: data.file_no,
                        surname: data.surname,
                        first_name: data.first_name,
                        other_name: data.other_name,
                        previous_name: data.previous_name,
                        rank: data.rank,
                        position: data.position,
                        department: data.department,
                        id: data.id
                    };
                    this.showAddRecord = true;
                }
            },
            loadStaffRecords() {
                this.emptyRecords();
                this.isLoadingBlade = false;
                if(this.id) {
                    this.setData(this.application);
                } else {
                    swal.fire("Session Expired!", "Session timeout, try again...", "warning");
                    window.location.href = '/';
                }
            },
            setData(application) {// set paginated function
                if(application && application.training_school) {
                    let res = application.training_school.staff;
                    this.consultantRecords = [];
                    this.paginatedItems = res;
                    this.pagination.total = this.paginatedItems.length; // get items total
                    let perPage = this.pagination.perPage; // get per page count
                    if(this.paginatedItems.length > perPage) {// paginate
                        let numberOfPages = Math.ceil(this.paginatedItems.length / perPage);
                        for (let index = 1; index <= numberOfPages; index++) {
                            this.consultantRecords.push(this.paginatedItems[index]);
                        }
                    } else {
                        this.consultantRecords = this.paginatedItems;
                    }
                }
            },
            paginate() {// paginate function
                this.consultantRecords = [];
                this.pagination.from = null;
                let page = this.pagination.number;
                let perPage = this.pagination.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);
                this.pagination.from = from;//get first item number
                return this.consultantRecords = this.paginatedItems.slice(from, to);
            },
            showPreviousPage() {// go to next page
                return this.displayConsultantData(true);
            },
            showNextPage() {// go to next page
                return this.displayFacilityData(true);
            },
            saveDoctorRecord() {
                this.isloading = true;
                let data = this.validatedInputs();// validate inputs
                if(data) {// save
                    this.preloader();// show loading
                    this.record.training_school_id = this.application.training_school.id;// add school id
                    let record = { staff_data : this.record , id : this.id };
                    this.updateSchoolData(record).then((res) => {
                        // this.loadApplication();
                        this.isloading = false;
                        if(res.status) {
                            this.showErrorStatus = false;
                            this.showAddRecord = false;
                            swal.fire("Record Added!", res.msg , "success");
                            // this.loadStaffRecords();// load appointments
                            this.addQualification(res.record, true);// show Doctor Qualifications 
                        } else {
                            swal.fire("Error Occurred!", "An error occurred, kindly reload page and try again", "warning");
                        }
                    }).
                    catch(() => {
                        this.isloading = false;
                        this.emptyRecords();
                        swal.fire("Error Occurred!", "An error occurred, kindly reload page and try again", "warning");
                    });
                } else {
                    this.isloading = false;
                }
            },
            showErrorMsg() {
                this.showInputErrorStatus = true
                this.errorType = 'warning'
                this.errorMsg = 'An error occurred, kindly reload page and try again';
                var self = this;
                setTimeout(function() { self.showInputErrorStatus = false; }, 5000);
            },
            validatedInputs() {
                let data = this.record;
                let appRecord = { surname: null, first_name: null, rank: null, position: null, department: null };
                appRecord.department = data.department == null ? this.showInuptError('Department') : data.department;
                appRecord.rank = data.rank == null ? this.showInuptError('Rank') : data.rank;
                appRecord.position = data.position == null ? this.showInuptError('Position') : data.position;
                appRecord.first_name = data.first_name == null ? this.showInuptError('First Name') : data.first_name;
                appRecord.surname = data.surname == null ? this.showInuptError('Surname') : data.surname;
                // appRecord.file_no = data.file_no == null ? this.showInuptError('File Number') : data.file_no;
                return this.isEmpty(appRecord) ? appRecord : false;
            },
            isEmpty(obj) {// check for empty field
                return ! Object.keys(obj).some(k => !obj[k]);
            },
            showInuptError(name) {
                this.isloading = false;
                this.showInputErrorStatus = true
                this.errorType = 'warning'
                this.errorMsg = 'Invalid ' + name + ' has been entered';
                var self = this;
                setTimeout(function() { self.showInputErrorStatus = false; }, 5000);
            },
            emptyRecords() {
                return this.record = {
                    file_no: null,
                    surname: null,
                    first_name: null,
                    other_name: null,
                    previous_name: null,
                    rank: null,
                    position: null,
                    department: null
                };
            },
            deleteRecord(id) {// delete examination
                this.preloader();// show loading
                let data = { staff_data : true , id : id };
                this.deleteSchoolData(data).then((res) => {
                    this.loadApplication();
                    if(res.status) {
                        swal.fire("Record Deleted!", res.msg , "success");
                        this.loadStaffRecords(); // load appointments
                    } else {
                        swal.fire("Error Occurred!", "An error occurred while deleting, try again", "warning");
                        this.loadStaffRecords(); // load appointments
                    }
                }).
                catch(() => {
                    swal.fire("Network Failure", "Reload page and try again...", "warning");
                    this.loadStaffRecords(); // load appointments
                });
            },
            addQualification(data, status) {
                this.staff = [];
                if(status) {
                    this.staff.push(data);
                    this.showQualPage = status;
                } else {
                    this.loadApplication();
                    this.showQualPage = status;
                }
            },
            displayUploadPage(status) {// show bulk upload page
                this.sheetRecords = [];
                this.showBulkUploadPage = status;
            },
            onFileSelected(event) {
                this.isLoadingBlade = true;
                this.sheetRecords = [];
                this.showBulkUploadPage = false;
                let status =  this.validateFile(event.target.files[0]);
                return status ? this.uploadExcelFile(event) : false;
            },
            uploadExcelFile(event) {
                                this.file = event.target.files[0];
                let fileReader = new FileReader();
                fileReader.readAsArrayBuffer(this.file);
                fileReader.onload = (e) => {
                    this.arrayBuffer = fileReader.result;
                    var data = new Uint8Array(this.arrayBuffer);
                    var arr = new Array();
                    for (var i = 0; i != data.length; ++i)
                    arr[i] = String.fromCharCode(data[i]);
                    var bstr = arr.join("");
                    var workbook = XLSX.read(bstr, { type: "binary" });
                    var first_sheet_name = workbook.SheetNames[0];
                    var worksheet = workbook.Sheets[first_sheet_name];
                    this.sheetRecords = XLSX.utils.sheet_to_json(worksheet, { raw: true });
                    this.isLoadingBlade = false;
                    this.showBulkUploadPage = true;
                };
            },
            validateFile(file) {
                const validFileTypes = ['xlsx'];// valid image format array
                var fileExt = file.name.split('.').pop().toLowerCase();
                var validExt = validFileTypes.includes(fileExt);
                let fileSize = file.size;// get selected file size
                if(validExt && fileSize <= 2000000) {// for valid file and size
                    return true;
                } else if(! validExt) {// invalid file
                    swal.fire("Invalid File!", "Only Excel (xlsx) file are accepted", "warning");
                    return false;
                } else if(fileSize > 2000000) {// big file
                    swal.fire("File is too large!", "File should be less than 2MB", "warning");
                    return false;
                }
            },
            uploadStaffNow() {// upload bulk staff function
                if(this.sheetRecords && this.sheetRecords.length > 0) {// upload now
                    let data = { id : this.id, records : this.sheetRecords, type: 'staff' };
                    this.preloader(); // show loading
                    this.uploadBulkSchoolStaff(data).then((res) => {
                        this.loadApplication();
                        this.isloading = false;
                        if(res.status) {
                            swal.fire("Record Added!", res.msg , "success");                           
                        } else {
                            swal.fire("Error Occurred!", "An error occurred, kindly reload page and try again", "warning");
                        }
                    }).
                    catch(() => {
                        this.isloading = false;
                        swal.fire("Error Occurred!", "An error occurred, kindly reload page and try again", "warning");
                        return this.displayUploadPage(false);
                    });
                    
                } else {
                    swal.fire("Upload Failed!", "No Staff was added, try again...", "warning"); 
                    return this.displayUploadPage(false);                   
                }
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        },
        created() {
            this.loadStaffRecords();// load appointments
        },
    }
</script>

<style>
.right {
    float: right;
}
</style>

<style>
    .form-control-label {
        width: 100%;
    }
</style>